



























































































// import { downloadFile, getTimestamp } from '@/shared/utility';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { SwIconButton } from '@libs-uuif/shared/sw-icon-button';
import { SwBlockingProgress } from '@libs-uuif/shared/sw-blocking-progress';
import { SwButton } from '@libs-uuif/shared/sw-button';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwFileUpload } from '@libs-uuif/shared/sw-file-upload';
import { SwModal, SwModalBody, SwModalFooter } from '@libs-uuif/shared/sw-modal';
import { SwTable, TableColumnConfig, TableEntry } from '@libs-uuif/shared/sw-table';
import { SwStatusInfo } from '@sonicwall/unified-ui-framework/src/shared/sw-status-info';
import { SwCheckbox } from '@libs-uuif/shared/sw-checkbox';
import { tooltip } from '@libs-uuif/shared/tooltip-dir';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { CsvRowData } from '../types/index';
import { InfoState } from '@/core/core.store';
import Papa from 'papaparse';
import moment from 'moment';
import { CreateElement, VNode } from 'vue';

@Component({
  components: {
    SwButton,
    SwModalBody,
    SwModalFooter,
    SwModal,
    SwFileUpload,
    SwTable,
    SwBlockingProgress,
    SwIcon,
    SwIconButton,
    SwCheckbox,
    SwStatusInfo,
  },
  directives: {
    tooltip,
  },
})
export default class BulkUploadServiceCotermModal extends SwExtendedVue {
  @Prop({ required: true }) visible!: boolean;

  cssPrefix = 'bulk-upload-service';
  errorMsg: string = '';
  customBlockingVisible: boolean = false;
  csvData: CsvRowData[] = [];
  statusData: TableEntry[] = [];
  browseFileNameEmpty: boolean = false;
  files: File[] = [];
  fileTypes: string = '.csv';
  fileexist: boolean = false;
  browseFileName: string = '';
  isValidationError: boolean = false;
  termAndCondition: boolean = false;
  screen: string = '1';
  batchId: string = '';
  orderId: string = '';
  isActivationEnabled: boolean = false;
  showNotification: boolean = false;

  @Watch('files')
  private onFileSelect() {
    if (this.files.length > 0) {
      this.showNotification = false;
      this.errorMsg = '';
      const file = this.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = () => {
          if (reader.result) {
            const parsedData = this.parseCSV(reader.result.toString());
            this.csvData = parsedData.filter(ele => ele.serialnumber !== '');
            if (this.csvData.length === 0) {
              this.errorMsg = this.$t('coterm.emptyCsvError').toString();
            } else if (this.csvData.length > 5000) {
              this.showNotification = true;
            }
          }
        };
        reader.readAsText(file);
      }
      if (!this.files[0].name.endsWith('.csv')) {
        this.isValidationError = true;
        this.browseFileNameEmpty = false;
      } else {
        this.browseFileNameEmpty = false;
        this.isValidationError = false;
        this.fileexist = this.files.length > 0;
        this.browseFileName = this.files[0].name;
      }
    }
  }

  serviceCotermTableConfig: TableColumnConfig[] = [
    {
      key: 'serialNumber',
      dataKey: 'serialNumber',
      sorter: true,
      width: 130,
      title: 'SERAIL NUMBER',
    },
    {
      key: 'servicefamilytext',
      dataKey: 'servicefamilytext',
      sorter: true,
      width: 130,
      title: 'SERVICE FAMILY',
    },
    {
      key: 'endDate',
      dataKey: 'endDate',
      sorter: true,
      width: 100,
      title: 'END DATE',
    },
    {
      key: 'cotermDate',
      dataKey: 'cotermDate',
      sorter: true,
      width: 100,
      title: 'COTERM DATE',
    },
    {
      key: 'status',
      dataKey: 'status',
      sorter: true,
      width: 100,
      title: 'STATUS',
    },
    {
      key: 'message',
      dataKey: 'message',
      sorter: true,
      width: 310,
      title: 'MESSAGE',
      render(h: CreateElement, data: { entry: TableEntry }): VNode { // tslint:disable-line
        return (
          <div style="color: red;">
            {data.entry.message}
          </div>
        ) as VNode;
      },
    },
  ];

  close(): void {
    this.$emit('close');
  }

  confirmBulkUpload(): void {
    if (this.browseFileName === '') {
      this.browseFileNameEmpty = true;
    } else if (this.files.length === 0) {
      this.errorMsg = this.$t('coterm.fileMissingError').toString();
    } else if (this.files[0].name.split('.').pop() !== 'csv') {
      this.errorMsg = this.$t('coterm.invalidCsvFileError').toString();
    } else if (!this.termAndCondition) {
      this.errorMsg = this.$t('coterm.requiredTCError').toString();
    } else {
      this.browseFileNameEmpty = false;
      this.errorMsg = '';
      const file = this.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = () => {
          if (reader.result) {
            const parsedData = this.parseCSV(reader.result.toString());
            this.csvData = parsedData.filter(ele => ele.serialnumber !== '');
            if (this.csvData.length > 0) {
              const payload = {
                arrBulkCotermActivation: this.csvData,
                mode: 'preview',
              };
              this.submitBulkUpload(payload);
            } else {
              this.errorMsg = this.$t('coterm.emptyCsvError').toString();
            }
          }
        };
        reader.readAsText(file);
      }
    }
  }

  onSubmit(): void {
    const arrMultiKeyActivation: any[] = [];
    this.csvData.forEach((item) => {
      const obj = {
        ...item,
        messageAccept: 'YES',
      };
      arrMultiKeyActivation.push(obj);
    });
    const payload = {
      arrBulkCotermActivation: arrMultiKeyActivation,
      mode: 'force',
      batchid: this.batchId,
    };
    this.submitBulkUpload(payload);
  }

  submitBulkUpload(payload: any): void {
    this.$store.commit('startLoading');
    this.$store.dispatch('SnbCoTermStoreModule/bulkCotermActivation', payload)
    .then((response) => {
      if (response.operationStatus === 'OK') {
        if (this.screen === '1') {
          this.batchId = response.batchid || '';
          this.isActivationEnabled = response.isActivationEnabled || false;
          const status = response.arrBulkCotermItemStatus || [];
          status.forEach((element: any, index: number) => {
            this.statusData.push({
              _key: `${index + 1}`,
              serialNumber: element.serialnumber,
              servicefamilytext: element.servicefamilytext,
              endDate: element.endDate,
              cotermDate: response?.arrBulkCotermActivationResult?.find((el: any) => {
                if ((el.serialnumber === element.serialnumber) && (el.servicefamilytext === element.servicefamilytext)) {
                  return true;
                }
              })?.cotermdate || '',
              status: element.status,
              message: element.errorMessage ? element.errorMessage : '',
            });
          });
          this.screen = '2';
        } else {
          this.orderId = response.eorderId || '';
          this.$emit('status', this.orderId);
        }
        this.$store.commit('stopLoading');
      } else {
        this.$store.commit('stopLoading');
        this.close();
        const message: InfoState = { infoType: 'high', infoMsg: response?.msgDesc };
        this.$store.commit('displayMessage', message);
      }
    })
    .catch(() => {
      this.$store.commit('stopLoading');
    });
  }

  parseData(data: string) {
    return data ? data.replace(/"/g, '').trim() : '';
  }

  convertDate(dateStr: string): string {
    if (!dateStr) return '';

    const m = moment(
      dateStr,
      [
        moment.ISO_8601,
        'DD-MMM-YYYY',
        'DD/MM/YYYY',
        'MM/DD/YYYY',
        'YYYY-MM-DD',
        'YYYY/MM/DD',
        'DD-MM-YYYY',
        'MMM DD, YYYY',
        'DD MMM YYYY',
      ],
      true,
    );

    if (!m.isValid()) return '';

    return m.format('MM/DD/YYYY');
  }

  parseCSV(csv: string): CsvRowData[] {
    const result = Papa.parse<string[]>(csv, {
      skipEmptyLines: true,
    });

    const rows = result.data;

    const extractedData: CsvRowData[] = [];

    for (let i = 1; i < rows.length; i += 1) {
      const data = rows[i];

      if (data.length > 0) {
        const inner: CsvRowData = {
          serialnumber: this.parseData(data[0]),
          friendlyName: this.parseData(data[1]),
          productLine: this.parseData(data[2]),
          tenantName: this.parseData(data[3]),
          serviceFamilyText: this.parseData(data[4]),
          endDate: this.convertDate(this.parseData(data[5])),
          messageAccept: '',
        };

        extractedData.push(inner);
      }
    }

    return extractedData;
  }

  filterDatatooltip() {
    return {
      enabled: true,
      placement: 'top',
      content: 'Service Coterm Bulk Activation Template',
      compact: true,
      includePopperForHover: true,
    };
  }

  getTimestamp(): string {
    const now = new Date();
    const mm = String(now.getMonth() + 1).padStart(2, '0');
    const dd = String(now.getDate()).padStart(2, '0');
    const yy = String(now.getFullYear()).slice(-2);
    const hh = String(now.getHours()).padStart(2, '0');
    const min = String(now.getMinutes()).padStart(2, '0');
    return `${mm}${dd}${yy}${hh}${min}`;
  }

  downloadFile(content: string, fileName: string) {
    const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', fileName);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  async downloadTemplate(value: number) {
    const serviceCotermBulkActivationColumns = ['serialNumber', 'friendlyName', 'productLine', 'tenantName', 'serviceName', 'endDate', 'messageAccept'];
    const tableData = await this.convertToCSV([], [], value, false, serviceCotermBulkActivationColumns);
    const csvContent = tableData;
    const timestamp = this.getTimestamp();
    const fileName = `ServiceCoterm${timestamp}.csv`;
    this.downloadFile(csvContent, fileName);
  }

  async convertToCSV(data: Record<string, unknown>[], dataFilter: Record<string, unknown>[], value: number, showData: boolean, columnNames: string[]): Promise<string> {
    const dataTable = [...(showData ? dataFilter : data)];
    let addRow: Record<string, unknown>;

    if (value === 1) {
      addRow = {
        serialNumber: '0017C5XXXXX',
        friendlyName: 'TestXXX',
        productLine: 'NSA E56XX',
        tenantName: 'TEST-1XXX',
        serviceName: 'Gateway 5XXXXX',
        endDate: '08/21/20XX',
        messageAccept: 'XXXX',
      };
    } else {
      addRow = {};
    }

    dataTable.unshift(addRow);
    const header = `${columnNames.map(name => name).join(',')}\n`;
    const rows = dataTable.map((row) => {
      let rowData = '';
      rowData += columnNames
      .map((col) => {
        return row.hasOwnProperty(col) ? `"${row[col]}"` : '';
      })
      .join(',');
      return rowData;
    });

    return header + rows.join('\n');
  }
}
